module.exports = __webpack_public_path__ + "static/img/zx-list.6398557f.png";